import { render, staticRenderFns } from "./CampaignInfoView.vue?vue&type=template&id=61ad3a56&scoped=true&"
import script from "./CampaignInfoView.vue?vue&type=script&lang=js&"
export * from "./CampaignInfoView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfoView.vue?vue&type=style&index=0&id=61ad3a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad3a56",
  null
  
)

export default component.exports